module.exports = __webpack_public_path__ + "static/img/button.8599fa40.png";